import { Component, input, output } from '@angular/core';
import { CustomTranslateService } from '@app/core/services/translate.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { QrCodeComponent } from 'ng-qrcode';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-wallet',
    templateUrl: './wallet.component.html',
    styleUrls: ['./wallet.component.scss'],
    imports: [
        QrCodeComponent,
        MatIcon,
        DatePipe,
        TranslateModule,
    ],
})
export class WalletComponent {
    showQrCode = input<boolean | undefined>(true);
    qrCodeValue = input<string | undefined>();
    qrHref = input<string | undefined>();
    date = input<number | undefined>();
    mapNr = input<string | undefined>();
    tourNr = input<string | undefined>();

    consigneeName = input<string | undefined>();
    carrierName = input<string | undefined>();
    consignorName = input<string | undefined>();

    qrClick = output<void>();

    currentLanguageCode: string | undefined;

    constructor(private customTranslateService: CustomTranslateService) {
        this.currentLanguageCode = this.customTranslateService.currentLang;
    }
}
